/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { BoxProps, Stack, StackProps, styled, Typography } from '@mui/material';
import { FC, PropsWithChildren } from 'react';

const PageHeaderRoot = styled(Stack, {
  name: 'PageHeader',
  slot: 'Root',
})(({ theme }) => ({
  height: theme.spacing(12.125),
  backgroundColor: theme.palette.common.white,
  borderColor: theme.palette.grey[200],
  borderBottomWidth: 1,
  borderBottomStyle: 'solid',
}));

type PageHeaderProps = PropsWithChildren<{
  title?: string;
  BoxProps?: BoxProps;
  StackProps?: StackProps;
}>;

const PageHeader: FC<PageHeaderProps> = ({ title, children, StackProps }) => {
  return (
    <PageHeaderRoot
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      {...StackProps}
    >
      {title && (
        <Typography component="h2" variant="h4" sx={{ fontSize: 26 }}>
          {title}
        </Typography>
      )}
      {children}
    </PageHeaderRoot>
  );
};

export default PageHeader;
